import { render, staticRenderFns } from "./RolesPanel.vue?vue&type=template&id=67274507&scoped=true&"
import script from "./RolesPanel.vue?vue&type=script&lang=js&"
export * from "./RolesPanel.vue?vue&type=script&lang=js&"
import style0 from "./RolesPanel.vue?vue&type=style&index=0&id=67274507&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67274507",
  null
  
)

export default component.exports